// social card styles

import styled, { css } from 'styled-components';

import { VerticalHorizontalCenterBlock } from '../../../../styled';

const chosenCardStyles = css`
  border: 2px solid ${(props) => props.theme.colors.action};
  background: rgba(0, 199, 126, 0.02);
  padding: 11px 15px;
  :hover {
    border: 2px solid ${(props) => props.theme.colors.action};
  }
`;

export const SocialCardWrapper = styled.div<{ chosen?: boolean; platformCard: boolean }>`
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid ${(props) => props.theme.colors.stroke};
  cursor: pointer;
  box-sizing: border-box;
  transition: transform ease-out 0.1s;
  :hover {
    border: 1px solid ${(props) => props.theme.colors.disabled};
  }
  :active {
    transform: ${(props) => !props.platformCard && 'scale(0.98)'};
  }
  ${(props) => props.chosen && chosenCardStyles}
`;

export const TopNavigationBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const SocialNetworkDescription = styled.div`
  display: flex;
`;

export const SocialCardTitle = styled.h3`
  font-size: 15px;
  line-height: 24px;
`;

export const SocialCardSubtitle = styled.p`
  font-size: 11px;
  line-height: 16px;
  color: ${(props) => props.theme.colors.muted};
`;

export const CardSpinner = styled(VerticalHorizontalCenterBlock)`
  height: 24px;
  width: 24px;
`;

export const SocialIconWrapper = styled(VerticalHorizontalCenterBlock)`
  margin-right: 8px;

  svg {
    width: 38px;
    height: 38px;
  }
`;
